import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { ReactComponent as BurgerIcon } from "../../assets/burger.svg";
import "./Menu.scss";
import useAuth from "../../auth/useAuth";
import { Avatar, Menu, MenuItem } from "@mui/material";

const Navigation = () => {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isShow, setShow] = useState(false);
  const { pathname, hash } = useLocation();

  const handleOpenModal = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseModal = () => {
    setAnchorEl(null);
  };
  const handleClick = (e) => {
    const toggleLink = document.querySelectorAll(".toggle-menu");
    toggleLink.forEach((item) => {
      if (item.classList.contains("active-toggle")) {
        item.classList.remove("active-toggle");
      }
    });
    e.target.parentNode.classList.toggle("active-toggle");
  };
  const toggleMobileMenu = () => {
    setShow(() => !isShow);
  };
  useEffect(() => {
    setShow(() => false);
  }, [hash, pathname]);
  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="top-main-header">
      <nav className="top-main-navbar">
          <ul className={`top-main-menu ${isShow && "active"}`}>
            <li className="top-toggle-menu" onClick={handleClick}>
              {isAdmin ? (
                <>
                  <a className="top-nav-link" href="/#section-features">Features</a>
                  <a className="top-nav-link" href="/#section-benefits">Benefits</a>
                  <a className="top-nav-link" href="/#section-brands">Our Brand</a>
                  <a className="top-nav-link" href="/#section-about">About</a>
                  <a className="top-nav-link" href="/#section-contact">Contacts</a>
                  <a className="top-nav-link" href="/#section-faqs">FAQ's</a>
                </>
              ) : (
                <>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "#section-features" ? "is-nav-active" : ""
                }`}
                to="/#section-features"
                smooth
              >
                Features
              </NavHashLink>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "#section-benefits" ? "is-nav-active" : ""
                }`}
                smooth
                to="/#section-benefits"
              >
                Benefits
              </NavHashLink>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "#section-brands" ? "is-nav-active" : ""
                }`}
                smooth
                to="/#section-brands"
              >
                Our Brand
              </NavHashLink>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "#section-about" ? "is-nav-active" : ""
                }`}
                smooth
                to="/#section-about"
              >
                About
              </NavHashLink>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "#section-contact" ? "is-nav-active" : ""
                }`}
                smooth
                to="/#section-contact"
              >
                Contacts
              </NavHashLink>
              <NavHashLink
                exact={true}
                className={`top-nav-link ${
                  hash === "/faqs" ? "is-nav-active" : ""
                }`}
                smooth
                to="/faqs"
              >
                FAQ's
              </NavHashLink>
                </>
              )}
            </li>
          </ul>
          <button className={`mobile-toggle-btn ${isShow && "active"}`} onClick={toggleMobileMenu}>
            <BurgerIcon />
          </button>
        </nav>
        <div className="top-user-block">
          {auth.isAuthenticated ? (
            <>
              <span className="profile__name">{auth.user.fullName}</span>
              <Avatar
                sx={{ cursor: "pointer" }}
                onClick={handleOpenModal}
              >
                {auth.user.firstName.charAt(0)}
              </Avatar>
              <span
                className="profile__logout"
                onClick={auth.logout}
              >
                Log out
              </span>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleCloseModal}
                elevation={0}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <MenuItem onClick={handleCloseModal}>
                  <NavLink
                    activeClassName="is-active"
                    className="top-nav-link custom-link"
                    to="/admin/overview"
                  >
                    Dashboard
                  </NavLink>
                </MenuItem>
              </Menu>
            </>
          ) : (
            <div className="nav__menu" onClick={handleClick}>
              <NavLink
                activeClassName="is-active"
                className="top-nav-link blue-link custom-link"
                to="/login"
              >
                Login
              </NavLink>
              <NavLink
                activeClassName="is-active"
                className="top-nav-link green-link custom-link"
                to="/signup"
              >
                Sign Up
              </NavLink>
            </div>
          )}
        </div>
      </div>
  );
};

export default Navigation;
